import { createFileRoute } from '@tanstack/react-router';
import { RelatorioCadastroRelacaoTransportadores } from '@/features/relatorio/page/cadastro/relacao-transportadores/RelatorioCadastroRelacaoTransportadores';

export const Route = createFileRoute('/a/relatorio/cadastro/relacao-transportadores')({
    component: RelatorioCadastroRelacaoTransportadores,
});
